export enum NameDisplayPreference {
    NAME_FIRST = 'Name, surname',
    SURNAME_FIRST = 'Surname, name',
}